import { buildUibComponentModal, defineThisScopeBinding, elementToModalRef } from "../../../ajs/ajs-migration-utils.js";
import { SimpleSpeechSynthesis } from "../../../classes/simple-speech-synthesis.js";
import { ContentCatalog } from "../content-catalog.js";

/** @see {@link https://gist.github.com/rodrigoborgesdeoliveira/987683cfbfcc8d800192da1e73adc486?permalink_comment_id=4342805#gistcomment-4342805} */
const youtube_id_regexp = /(?<=[=\/&])[a-zA-Z0-9_\-]{11}(?=[=\/&?#\n\r]|$)/;

const instagram_src_regexp = /^https:\/\/www.instagram.com\/(p|reel)\/([a-zA-Z0-9_\-]{10,})/;


export class CatalogItemViewerModalComponent {

    static selector = "modal-catalog-item-viewer";
    static template = `
        <a class="close-btn" href="javascript:void(0)" ng-click="close()"></a>

		<style type="text/css">
			@media (max-width: 992px) {
				body.modal-open > .modal > .modal-dialog.modal-lg {
					width: calc( 100% - 60px );
				} 
			}
		</style>

        <div class="modal-header">
            <div class="row">
                <div class="col-xs-12">
                    <div class="pull-left">
                        <button class="btn btn-sm btn-default" style="margin:0px 3rem 0px -60px" ng-if="getPrevItem()" ng-click="goToItem(getPrevItem())"><b class="glyphicon glyphicon-chevron-left"></b>&nbsp;{{ 'Previous catalog item' | translate }}</button>
                        <button class="btn btn-sm btn-default" ng-click="goToCatalogViewer()"><b class="glyphicon glyphicon-list"></b>&nbsp;{{ 'Click to view catalog' | translate }}</button>
                        <button class="btn btn-sm btn-default" ng-click="goToLookAtItem( item )"><b class="glyphicon glyphicon-eye-open"></b>&nbsp;{{ 'Click to look at mesh' | translate }}</button>
                    </div>
                    <div class="pull-right">
                        <button class="btn btn-sm btn-default" style="margin-right:-60px;" ng-if="getNextItem()" ng-click="goToItem(getNextItem())">{{ 'Next catalog item' | translate }}&nbsp;<b class="glyphicon glyphicon-chevron-right"></b></button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-body">
            <div class="row">

                <div class="col-xs-12" ng-class="{'col-md-6': media_array.length||(!item.primary_image_hidden&&catalogsService.getItemMediaSrc( item )) }">
                    <button class="pull-right btn btn-sm" ng-click="content_speech_synthesis.toggle()" ng-if="content_speech_synthesis != null">
                        <span ng-hide="content_speech_synthesis.speaking">Lue ääneen</span>
                        <span ng-hide="!content_speech_synthesis.speaking">Keskeytä</span>
                    </button>

                    <h4 class="media-heading">{{ catalogsService.getItemHeading( item ) }}</h4>
                    <p>{{ catalogsService.getItemDescription( item ) }}</p>
                </div>

                <div class="col-xs-12 col-md-6" ng-if="!item.primary_image_hidden" style="text-align: -webkit-center;">
                    <a ng-click="openItemMediaViewerModal( item )">
                    	<img class="img-responsive" style="max-height: 50vh;" src="/i/null?size=small" ng-src="{{ catalogsService.getItemMediaSrc( item, 'large' ) }}">
					</a>
                </div>

                <div class="col-xs-12 col-md-6" ng-repeat="media in media_array">
                    <div class="row">

                        <div ng-if="media.type == 'iframe'" class="col-xs-12">
                            <div class="embed-responsive embed-responsive-4by3">
                                <iframe class="embed-responsive-item" type="text/html" allowfullscreen ng-src="{{ media.src }}"></iframe>
                            </div>        
                        </div>

                        <div ng-if="media.type == 'embed'" class="col-xs-12" ng-switch="media.vendor">
                            <div ng-switch-when="instagram">
                                <blockquote class="instagram-media" data-instgrm-captioned data-instgrm-permalink="{{ media.src }}" data-instgrm-version="14" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);">
                                    <div style="padding:16px;">
                                        <a href="{{ media.src }}" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank">
                                            <div style=" display: flex; flex-direction: row; align-items: center;">
                                                <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div>
                                                <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;">
                                                    <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div>
                                                    <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div>
                                                </div>
                                            </div>
                                            <div style="padding: 19% 0;"></div>
                                            <div style="display:block; height:50px; margin:0 auto 12px; width:50px;">
                                                <svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink">
                                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g>
                                                </svg>
                                            </div>
                                            <div style="padding-top: 8px;">
                                                <div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">Näytä tämä julkaisu Instagramissa</div>
                                            </div>
                                            <div style="padding: 12.5% 0;"></div>
                                            <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;">
                                                <div>
                                                    <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div>
                                                    <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div>
                                                    <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div>
                                                </div>
                                                <div style="margin-left: 8px;">
                                                    <div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div>
                                                    <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div>
                                                </div>
                                                <div style="margin-left: auto;">
                                                    <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div>
                                                    <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div>
                                                    <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div>
                                                </div>
                                            </div>
                                            <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;">
                                                <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div>
                                                <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div>
                                            </div>
                                        </a>
                                        <p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;">
                                            <a href="{{ media.src }}" style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;" target="_blank">Katso julkaisu Instagramissa</a>
                                        </p>
                                    </div>
                                </blockquote>
                                <script async src="//www.instagram.com/embed.js"></script>
                            </div>

                            <div ng-switch-default class="embed-responsive embed-responsive-4by3">
                                <iframe class="embed-responsive-item" type="text/html" allowfullscreen ng-src="{{ media.src }}"></iframe>
                            </div>
                        </div>

                        <div ng-if="media.type == 'video'" class="col-xs-12">
                            <video class="w-100" controls ng-src="{{ media.src }}"></video>
                        </div>

                        <div ng-if="media.type == 'audio'" class="col-xs-12">
                            <audio class="w-100" controls ng-src="{{ media.src }}"></audio>
                        </div>

                        <div ng-if="media.type == 'image'" class="col-xs-12">
                            <a ng-click="openItemMediaViewerModal( item, media )">
								<img class="img-responsive" style="max-height:50vh;" ng-src="{{ media.src }}">
							</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;

    item_idx;

    media_array = [];

    content_speech_synthesis = null;

    static $inject = [ "$scope", "$element", "$sce", "gameSceneService", "catalogsService", 'gettextCatalog', 'modalOpener', '$injector', '$playerHandler' ];

    constructor(
        $scope,
        modalRef,
        $sce,
        gameSceneService,
        catalogsService,
        gettextCatalog,
		modalOpener,
        $injector,
        playerHandlerService
    ) {
        this.$scope = $scope;
        this.modalRef = elementToModalRef('modal-catalog-item-viewer');
        this.$sce = $sce;
        this.gameSceneService = gameSceneService;
        this.catalogsService = catalogsService;
        this.gettextCatalog = gettextCatalog;
		this.modalOpener = modalOpener;
        this.$injector = $injector;
        this.playerHandlerService = playerHandlerService;

        defineThisScopeBinding( this, $scope, [ 'item', 'catalog', 'arrangement', 'modalRef', 'media_array', 'item_idx', 'content_speech_synthesis','close','goToLookAtItem','goToCatalogViewer', 'getNextItem', 'getPrevItem', 'goToItem', 'openItemMediaViewerModal', 'playerHandlerService', ...CatalogItemViewerModalComponent.$inject ]);
    }

    async $onInit() {

        if (!this.item || !this.catalog || !this.arrangement) {
            return this.close();
        }

        let catalogs = this.arrangement.catalogs;

        if (!catalogs || !catalogs.length || catalogs.indexOf( this.catalog ) == -1) {
            return this.close();
        }

        this.item_idx = this.catalog.items.indexOf( this.item );

        if (this.item_idx == -1) {
            return this.close();
        }

        if (this.item.media) {
            this.media_array = this.item.media.map( media => {

                let { src, type } = media;
                let vendor;

                if (!type || !src) return;

                if (type.indexOf( "audio/" ) == 0) {
                    //if (excludedCommonAudioMimes.indexOf( type ) == -1)
                    type = "audio/*";
                }

                if (type.indexOf( "image/" ) == 0) {
                    //if (excludedCommonImageMimes.indexOf( type ) == -1)
                    type = "image/*";
                }

                if (type === "iframe") {
                    if (src.match( instagram_src_regexp )) {
                        type = "embed";
                        vendor = "instagram";
                    }
                }

                switch (type) {
                    case "video/*":
                        return {
                            type: "video",
                            src:  this.$sce.trustAsResourceUrl( src )
                        };

                    case "audio/*":
                        return {
                            type: "audio",
                            src:  this.$sce.trustAsResourceUrl( src )
                        };

                    case "image/*":
                        return {
                            type: "image",
                            src:  this.$sce.trustAsResourceUrl( src )
                        };

                    /**
                     * Kustomoidut tapaukset, joissa annetaan jotain muuta kuin verkko-osoite
                     */

                    case "video/vnd.youtube.yt":

                        let match = src.match( youtube_id_regexp );

                        if (match && match[0]) {
                            src = `//www.youtube.com/embed/${ match[0] }?enablejsapi=1`;
                        }
                        // Fallthrough
                            
                    case "iframe":
                    case "embed":
                        if (vendor) {
                            return {
                                vendor,
                                type: "embed",
                                src:  this.$sce.trustAsResourceUrl( src )
                            };
                        } else {
                            return {
                                type: "iframe",
                                src:  this.$sce.trustAsResourceUrl( src )
                            };
                        }
    
                }

            }).filter( media => media && media.type );
        }

        try {
            if (this.item.type == "client_oeuvre") {
                await this.catalogsService.getClientOeuvreItemAsync( this.item );
            }

            let content = [ this.catalogsService.getItemHeading( this.item ),this.catalogsService.getItemDescription( this.item ) ].filter( v => v ).join( ".\n\n" );

            this.content_speech_synthesis = SimpleSpeechSynthesis.FromHtml( content );

            /** AJS */
            this.content_speech_synthesis.onstart = () => { this.$scope.$apply(); }

            this.$scope.$on("$destroy", () => {
                if (this.content_speech_synthesis) this.content_speech_synthesis.cancel();
            });
            /********/

        } catch (error) {}
    }

    close() {
        this.modalRef.hide();
    }

	openItemMediaViewerModal( item, media ) {

		let options;

		if (media) {
			if (media.type == 'image' && media.src) {

				options = {
					file: {
						type: 'image',
						src: `${ media.src }`
					}
				};

			} else {
				return console.warn( "Not implemented!" ); // @TODO
			}
		}

		if (!options && item.type == 'client_oeuvre') {
			let result = this.catalogsService.getClientOeuvreItem( item );

			if (result) {
				let { media_src, client_oeuvre } = result;

				if (client_oeuvre && client_oeuvre.with && client_oeuvre.with.oeuvre && client_oeuvre.with.oeuvre.img_uid) {

					options = {
						uid: client_oeuvre.with.oeuvre.img_uid
					};

				} else if (media_src) {

					options = {
						file: {
							type: 'image',
							src: media_src
						}
					};
				}
			}
		}

		if (options) {

			options.download = false;

			this.modalOpener.openRegisteredModal( "file-previewer", options );
		}
	}

    goToCatalogViewer() {

        this.catalogsService.openCatalogViewer( this.arrangement, this.catalog );

        this.close();
    }

    getNextItem() {
        return this.catalog.items[ this.item_idx + 1 ];
    }

    getPrevItem() {
        return this.catalog.items[ this.item_idx - 1 ];
    }

    goToItem( item ) {

        this.catalogsService.openCatalogItemViewer( item, this.catalog, this.arrangement );

        this.close();
    }

    goToLookAtItem( item ) {

        if (this.catalogsService.adjustPlayerToLookItem( item )) {

            this.playerHandlerService.doGoToCatalogItem( item, this.catalog );
            this.close();

        }
    }
}




export const AjsCatalogItemViewerModalComponent = buildUibComponentModal( "modalCatalogItemViewer", CatalogItemViewerModalComponent, {
    bindings: {
        item: '<',
        catalog: '<',
        arrangement: '<'
    }
}, {
    size: 'lg'
});
